export default __webpack_public_path__ + "static/media/warning-white-large.49cf97b3.svg";